module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-6-min.ab320f66.jpg";